import { Static, Object, Record, String, Number, Literal, Union, Array, Optional } from '@sinclair/typebox';

import { BoundFlight, UpsellTable } from '../../flightOffers';
import { TripType } from '../../sas-domain/common';
import { FareRules } from '../../sas-domain/fareRules';
import { Coupon } from '../../sas-domain/pointsPricing';

export type AwardFlightsQueryParams = Static<typeof AwardFlightsQueryParams>;
export const AwardFlightsQueryParams = Object({
  origin: String(),
  destination: String(),
  outboundDate: String({
    examples: ['2024-08-20'],
    pattern: '^20(2[4-9]|[3-9][0-9])-[0-9]{2}-[0-9]{2}$',
  }),
  adults: Number(),
  children: Number(),
  infants: Number(),
  tripType: Union([Literal(TripType.ONE_WAY), Literal(TripType.ROUND_TRIP)], {
    examples: [TripType.ONE_WAY, TripType.ROUND_TRIP],
  }),
  inboundDate: Optional(
    String({
      description: `Required when trip type is ${TripType.ROUND_TRIP}`,
      examples: ['2024-08-30'],
      pattern: '^20(2[4-9]|[3-9][0-9])-[0-9]{2}-[0-9]{2}$',
    })
  ),
  selectedCouponCodes: Optional(String()),
});

export type AwardFlightsResponse = Static<typeof AwardFlightsResponse>;
export const AwardFlightsResponse = Object({
  offerId: String(),
  tripType: Union([Literal(TripType.ONE_WAY), Literal(TripType.ROUND_TRIP)]),
  outboundFlights: Array(BoundFlight),
  inboundFlights: Optional(Array(BoundFlight)),
  fareRules: Record(String(), FareRules),
  upsellTable: UpsellTable,
  coupons: Optional(Array(Coupon)),
});
